import React, { useEffect, useState } from 'react';
import Paper from '../../components/Paper';
import Text from '../../components/Text';
import Radio from '../../components/Radio';
import { createUseStyles } from 'react-jss';
import {currencyName,FLAVOUR} from '../../config/serverInfo';
export interface DeliveryMethodProps {
  method: string;
  onChange: (name: string, value: any) => any;
  deliveryCost: number;
}

const DeliveryMethod: React.FC<DeliveryMethodProps> = ({
  method,
  onChange,
  deliveryCost,
}) => {
  const classes = useStyles();
  useEffect(() => {
  }, [])
   
  return (
    <Paper withShadow={false}className="p-3">
      <Text as="h5" className="mb-3" bold>
        Choose delivery method
      </Text>
      <div>
        <label className={classes.label}>
          <div>
            <Radio
              onChange={onChange}
              checked={method === 'deliver'}
              value="deliver"
            />
            <Text className="pb-2 ml-2" bold>
              {FLAVOUR === 'US' ? 'Deliver on address "USPS (4 to 7 days)"' : 'Deliver on address'} 
            </Text>
          </div>
          {/* USD TASK */}
            <div>
              <Text>Delivery Fee: {deliveryCost} {currencyName}</Text>
            </div>
          {/* <input type="radio" value="deliver" /> */}
        </label>
        {/* <label className={classes.label}>
          <div>
            <Radio
              onChange={onChange}
              checked={method === 'pickup'}
              value="pickup"
            />
            <Text className="pb-2 ml-2" bold>
              Pickup
            </Text>
          </div>
        </label> */}
      </div>
    </Paper>
  );
};

const useStyles = createUseStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div': {
      display: 'flex',
      '& > p': {
        margin: 0,
      },
      '& > div': {
        margin: 0,
      },
    },
  },
});

export default DeliveryMethod;
